// Current User Plugin
const CurrentUser = {
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install(Vue, options) {
    // get the currentUser from localStorage
    try{
      let user = localStorage.getItem('app_user')
      Vue.prototype.$currentUser = (user) ? JSON.parse(user) : null
    }
    catch(error){
      console.error(error);
      alert('This site will not work, without being able to set cookies and site-data. Please unkcheck "Block third-party cookies and site data" checkbox is set in Content Settings of your browser.');
    }
  }
};
  
export default CurrentUser;